export const GOOGLE_MAPS_API_KEY = 'AIzaSyDhXgQ1qffA9WawUp3LDzUqKpFNaXUmm8g';
